import { Type, type Static } from "@sinclair/typebox";

export const FicIdentityReviewQuerySchema = Type.Object(
  {
    managementYear: Type.Integer({ minimum: 2000, maximum: 2100 }),
  },
  { additionalProperties: false },
);
export const FicIdentityResolveSchema = Type.Object(
  {
    ...FicIdentityReviewQuerySchema.properties,
    operationId: Type.String({ format: "uuid" }),
    companyId: Type.String({ format: "uuid" }),
    kind: Type.Union([Type.Literal("client"), Type.Literal("quote")]),
    externalId: Type.String({ minLength: 1, maxLength: 200 }),
    clientId: Type.String({ format: "uuid" }),
    revision: Type.String({ pattern: "^[a-f0-9]{64}$" }),
  },
  { additionalProperties: false },
);
export type FicIdentityResolve = Static<typeof FicIdentityResolveSchema>;
export interface FicIdentityCandidate {
  id: string;
  name: string;
  taxCode: string | null;
  vatNumber: string | null;
}
export interface FicIdentityReviewItem {
  kind: "client" | "quote";
  externalId: string;
  label: string;
  sourceName: string | null;
  sourceIdentity?: {
    externalId: string | null;
    taxCode: string | null;
    vatNumber: string | null;
  };
  reviewReason?:
    | "shared-client-identity"
    | "client-choice-invalid"
    | "quote-choice-invalid"
    | "quote-client-id-missing"
    | "quote-client-unresolved";
  selectedClientId: string | null;
  needsReview: boolean;
  candidateIds: string[];
}
export interface FicIdentityReview {
  companyId: string | null;
  revision: string;
  clients: FicIdentityCandidate[];
  items: FicIdentityReviewItem[];
}
